"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blob = void 0;
const IonText_1 = require("../IonText");
const IonTypes_1 = require("../IonTypes");
const Lob_1 = require("./Lob");
/**
 * Represents a blob[1] value in an Ion stream.
 *
 * [1] http://amzn.github.io/ion-docs/docs/spec.html#blob
 */
class Blob extends (0, Lob_1.Lob)(IonTypes_1.IonTypes.BLOB) {
    /**
     * Constructor.
     * @param data          Raw, unsigned bytes to represent as a blob.
     * @param annotations   An optional array of strings to associate with `data`.
     */
    constructor(data, annotations = []) {
        super(data, annotations);
    }
    /**
     * Converts this Blob to a base64-encoded string when being serialized with `JSON.stringify()`.
     */
    toJSON() {
        return (0, IonText_1.toBase64)(this);
    }
    writeTo(writer) {
        writer.setAnnotations(this.getAnnotations());
        writer.writeBlob(this);
    }
}
exports.Blob = Blob;
